// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PaymentMethodChecksRequestDTO
 */
export interface PaymentMethodChecksRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodChecksRequestDTO
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodChecksRequestDTO
     */
    customerActionType: PaymentMethodChecksRequestDTOCustomerActionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentMethodChecksRequestDTOCustomerActionTypeEnum {
    REPOSITABOUTYOU = 'REPOSIT_ABOUT_YOU',
    REPOSITADDRESSHISTORY = 'REPOSIT_ADDRESS_HISTORY',
    REPOSITCONFIRM = 'REPOSIT_CONFIRM',
    REPOSITSIGN = 'REPOSIT_SIGN',
    REPOSITPAY = 'REPOSIT_PAY',
    REPOSITREFERENCING = 'REPOSIT_REFERENCING',
    REPOSITSIGNADDENDUM = 'REPOSIT_SIGN_ADDENDUM',
    CLAIMPAY = 'CLAIM_PAY',
    CLAIMPAYREMAININGBALANCE = 'CLAIM_PAY_REMAINING_BALANCE',
    CLAIMPROPOSALPAYREMAININGBALANCE = 'CLAIM_PROPOSAL_PAY_REMAINING_BALANCE',
    ARBITRATIONPAY = 'ARBITRATION_PAY',
    ARBITRATIONPAYREMAININGBALANCE = 'ARBITRATION_PAY_REMAINING_BALANCE',
    TOPUPPAY = 'TOP_UP_PAY',
    ARBITRATIONADMINPAY = 'ARBITRATION_ADMIN_PAY'
}



